/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const GlobeBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0c4.432 0 8 3.568 8 8s-3.568 8-8 8-8-3.568-8-8 3.568-8 8-8zm0 1a6.983 6.983 0 00-6.478 4.333l4.35 4.833a.5.5 0 01.12.243L6 10.5v1c0 .248.064.334.262.403.183.063.396.087.823.095L7.5 12a.5.5 0 01.492.41L8 12.5 7.999 15H8a6.978 6.978 0 004.952-2.042l-.322-.872-.127-.3c-.207-.464-.393-.734-.48-.78L12 11h-1.5a.5.5 0 01-.492-.41L10 10.5V8.408L10.013 8H4.5a.5.5 0 01-.492-.41L4 7.5v-2a.5.5 0 01.41-.492L4.5 5h2.115l.33.002L7 5V3.5a.5.5 0 01.41-.492L7.5 3h2c.284 0 .348-.017.388-.107l.015-.038c.06-.173.085-.411.093-1.015L10 1.287A7.049 7.049 0 008 1zM1 8a6.982 6.982 0 006 6.93v-1.934l-.116-.003c-.372-.011-.61-.042-.846-.112l-.102-.033c-.549-.19-.882-.596-.93-1.194L5 11.5v-.808L1.173 6.44A7.078 7.078 0 001 8zm9.996-6.333l-.003.387c-.013.598-.05.854-.145 1.13-.187.536-.576.778-1.19.812L9.5 4H8v1c0 .383-.138.681-.417.85l-.111.057c-.16.07-.284.092-.519.096l-.35-.002L5 6v1h5c.73 0 .98.429 1.002 1.115l-.001.308L11 10h1c.66 0 1.064.526 1.477 1.515l.116.291.102.276A6.982 6.982 0 0015 8a6.983 6.983 0 00-4.004-6.333z"
        />
    </AccessibleSVG>
);

export default GlobeBadge16;
